// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"198":"ec8cfe4c","464":"13880b5d","719":"d10021eb","787":"5128b469"}[chunkId] + ".chunk.js";
};